var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
export default {
  name: 'Links',
  components: {
    MdmLink: MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    footerLinks: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};